/**
 * @file TermsPage.tsx
 * @description Public terms-of-service at /terms. Same render pattern as
 *   PrivacyPolicyPage: section keys iterated through PolicySection.
 * @module Pages
 * @security No user input. MVP-grade text drafted alongside the code;
 *   not a substitute for legal review before commercial launch.
 */

import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { PolicyLayout, PolicySection } from '../components/common/PolicyLayout';
import { PublicFooter } from '../components/common/PublicFooter';

const SECTION_KEYS = [
  'what',
  'eligibility',
  'responsibilities',
  'files',
  'quotes',
  'availability',
  'termination',
  'liability',
  'ip',
  'governing_law',
  'changes',
  'contact',
] as const;

export default function TermsPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <PolicyLayout
        titleKey="terms.title"
        effectiveDateKey="terms.effective_date"
        versionKey="terms.version"
      >
        <p>{t('terms.intro')}</p>
        {SECTION_KEYS.map((key) => (
          <PolicySection
            key={key}
            titleKey={`terms.sections.${key}.title`}
            bodyKey={`terms.sections.${key}.body`}
          />
        ))}
      </PolicyLayout>
      <PublicFooter />
    </>
  );
}
